import { render } from "./HeroSliderComponent.vue?vue&type=template&id=74593d53&scoped=true"
import script from "./HeroSliderComponent.vue?vue&type=script&lang=js"
export * from "./HeroSliderComponent.vue?vue&type=script&lang=js"

import "./HeroSliderComponent.vue?vue&type=style&index=0&id=74593d53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ahmed.shaker.KORABIA\\Desktop\\hesabtech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74593d53"]])

export default __exports__